import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

export const ButtonText = withTypography({
  color: primitive.$mayoEggWhite,
  textAlign: 'center',
  fontFamily: 'heading',
});

export const SubHeading = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: '$4',
});

export const Section = Box.withConfig({
  marginY: '$3',
});

export const Container = Box.withConfig({
  width: 'full',
});
